/**
 * Module JS
 *
 * JS for ACF Pro derived modules.
 */
import './blocks';
